import {
  PROFILE_INFO,
  PROFILE_PHOTO,
  PROFILE_TIMEZONE,
} from "../actions/types";

const initialState = {};

function initState(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case PROFILE_INFO:
      return { ...state, info: payload };

    case PROFILE_PHOTO:
      return { ...state, photo: payload };

    case PROFILE_TIMEZONE:
      return { ...state, timezone: payload };

    default:
      return state;
  }
}

export default initState;
